<template>
    <transition name="fade">
        <div>
            <div class="row">
                <div class="col-sm-5">
                    <div class="form-group">
                        <label>Government Issued I.D<span class="text-danger">*</span></label>
                        <v-select :options="gov_ids" label="id_name" :reduce="id_name => id_name.id_code" :class="{'vs-invalid': $v.form.id_code.$error}"
                            placeholder="- Select -" :clearable="false" v-model="form.id_code" />
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>I.D. Number<span class="text-danger">*</span></label>
                        <input class="form-control form-control-sm text-uppercase" v-model="form.id_number" :class="{'is-invalid': $v.form.id_number.$error}" />
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="form-group">
                        <label>Expiry Date</label>
                        <input-calendar v-model="form.expiry_date" class="form-control form-control-sm" id="expiry_date" v-input-mask data-inputmask-alias="datetime" data-inputmask-inputformat="mm/dd/yyyy" maxDate="12/31/2099" />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-1"></div>
                <div class="col-sm-10">
                    <div class="alert alert-info2 text-justify">
                        <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>
                        <span class="text-justify fs-15">Only accepts <b>png, jpg, jpeg file format</b>. If you’re using a computer or a laptop, you may only upload an existing photo. If you’re using your mobile phone/tablet/IPAD, you may upload a government-issued ID with photo and signature.</span>
                    </div>
                    <div class="attachment-block clearfix" :style="{borderColor: $v.form.avatar.$error ? '#dc3545' : ''}">
                        <div class="text-center">
                            <img :src="fileURL" class="img-fluid" style="max-height: 300px;" v-if="form.avatar">
                            <img class="img-fluid" src="images/image_placeholder.jpg" v-else>
                        </div>
                    </div>
                    <div class="text-center">
                        <p v-if="$v.form.avatar.$error" class="danger fs-14">Required</p>
                        <label class="btn btn-sm btn-primary nowrap pointer">
                            Browse/Capture
                            <input type="file" hidden accept=".png, .jpg, .jpeg" @change="onUpload">
                        </label>
                    </div>
                </div>
                <div class="col-sm-1"></div>
            </div>
            <div class="row">
                <div class="col-12">
                    <button class="btn btn-outline-primary" @click="$emit('next', 2)"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                    <button class="btn btn-primary float-right" @click="btnNext()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>



            <div class="modal fade" id="modalID" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">All you'll need to complete your profile is</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-1"></div>
                                <div class="col-10">
                                    <div class="row">
                                        <span>- one valid photo-bearing government ID</span>
                                    </div>
                                    <div class="row">
                                        <b>Government IDs:</b>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="form-group">
                                                <p class="p-0 mb-0 text-danger">Passport</p>
                                                <p class="p-0 mb-0 text-danger">Driver's License</p>
                                                <p class="p-0 mb-0 text-danger">Philhealth Card</p>
                                                <p class="p-0 mb-0 text-danger">SSS ID</p>
                                                <p class="p-0 mb-0 text-danger">PhilSys ID</p>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">
                                                <p class="p-0 mb-0 text-danger">PRC ID</p>
                                                <p class="p-0 mb-0 text-danger">GSIS e-Card</p>
                                                <p class="p-0 mb-0 text-danger">Postal ID</p>
                                                <p class="p-0 mb-0 text-danger">Voter's ID</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <b>Other Government IDs:</b>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="form-group">
                                                <p class="p-0 mb-0 text-danger">NBI Clearance</p>
                                                <p class="p-0 mb-0 text-danger">Police Clearance</p>
                                                <p class="p-0 mb-0 text-danger">Barangay Clearance</p>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">
                                                <p class="p-0 mb-0 text-danger">OFW ID</p>
                                                <p class="p-0 mb-0 text-danger">Seaman's Book</p>
                                                <p class="p-0 mb-0 text-danger">Senior Citizen Card</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <span>- a well lit room to take photos of your ID</span>
                                    </div>
                                    <div class="row">
                                        <span>- to allow this site to access your camera</span>
                                    </div>

                                </div>
                                <div class="col-1"></div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary px-4" data-dismiss="modal">OK</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </transition>
</template>
<script>
    // api
    import {
        apiRefGovID
    } from "@js/api/getReferences";
    import {
        required
    } from "vuelidate/lib/validators";
    export default {
        data() {
            return {
                fileURL: '',
                form: {
                    borrower_id: null,
                    id_code: null,
                    id_number: null,
                    expiry_date: null,
                    avatar: null,
                },
                gov_ids: [],
                fileImage: ['image/jpeg', 'image/png', 'image/jpg', 'image/JPEG', 'image/PNG', 'image/JPG']
            }
        },

        validations() {
            return {
                form: {
                    id_code: {
                        required
                    },
                    id_number: {
                        required
                    },
                    // expiry_date: {
                    //     required
                    // },
                    avatar: {
                        required
                    },
                }
            }
        },

        created() {
            this.initData();
        },
        methods: {
            btnNext() {
                this.$v.form.$touch();
                if (this.$v.form.$invalid) {
                    const err = {
                        response: {
                            data: {
                                message: "Please complete all required fields",
                            }
                        }
                    };
                    this.$emit('error', err);
                } else {
                    this.postStep3();
                }
            },
            postStep3() {
                let formData = new FormData();
                formData.append('borrower_id', this.form.borrower_id);
                formData.append('id_code', this.form.id_code);
                formData.append('id_number', this.form.id_number);
                formData.append('expiry_date', this.form.expiry_date || '');
                formData.append('photo', this.form.avatar);

                Fire.$emit('loader', 1)
                axios
                    .post("/api/sblaf-prereg-post-step3", formData)
                    .then(res => {
                        Fire.$emit('loader', -1)
                        this.$emit('next', 4);
                    })
                    .catch(err => {
                        this.$emit('error', err);
                        Fire.$emit('loader', -1)
                    });
            },

            async getStep3() {
                try {
                    const res = await axios.get("/api/sblaf-prereg-step3");
                    return res.data;
                } catch (err) {
                    throw err;
                }
            },
            async getImage(filename) {
                try {
                    const res = await axios.get("/api/v2-files", {
                        params: {
                            filename: filename
                        },
                        responseType: 'blob'
                    });
                    return res;
                } catch (err) {
                    throw err;
                }
            },
            async initData() {
                Fire.$emit('loader', 1);
                try {
                    this.gov_ids = await apiRefGovID();
                    this.form = await this.getStep3();

                    if (this.form.avatar) {
                        const res = await this.getImage(this.form.avatar);
                        if (res.status == 200) {
                            this.fileURL = window.URL.createObjectURL(res.data);
                        }
                        if (res.status == 204) {
                            this.form.avatar = '';
                        }
                    }
                    if (this.form.expiry_date) {
                        this.form.expiry_date = moment(this.form.expiry_date).format('YYYY-MM-DD')
                    }
                    Fire.$emit('loader', -1);

                    $('#modalID').modal('show');
                } catch (err) {
                    this.$emit('error', err);
                    Fire.$emit('loader', -1);
                }
            },

            invalidFileFormat() {
                Swal.fire({
                    icon: 'warning',
                    title: 'Error',
                    text: 'You are uploading unsupported file format',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                })
            },

            onUpload($event) {
                let file = $event.target.files[0];
                if (file) {
                    if (this.fileImage.includes(file['type'])) {
                        this.form.avatar = file;
                        if (this.fileURL) {
                            window.URL.revokeObjectURL(this.fileURL);
                            this.fileURL = window.URL.createObjectURL(file);
                        } else {
                            this.fileURL = window.URL.createObjectURL(file);
                        }
                    } else {
                        this.invalidFileFormat();
                    }
                } else {}
            },
        },
    }
</script>